export const TITLE_OPTIONS = ["Mr.", "Mrs.", "Ms.", "Mstr."];

export const SUFFIX_OPTIONS = ["Jr", "Sr", "II", "III", "IV", "V"];

export const GENDER_OPTIONS = ["Male", "Female", "Other"];

export const MARITAL_STATUS_OPTIONS = [
  "Single",
  "Married",
  "Divorced",
  "Widowed",
];

export const RELATIONSHIP_OPTIONS = [
  "Spouse",
  "Mother",
  "Father",
  "Daughter",
  "Son",
  "Brother",
  "Sister",
  "Grandmother",
  "Grandfather",
  "Granddaughter",
  "Grandson",
  "Aunt",
  "Uncle",
  "Nephew",
  "Neice",
  "Friend",
  "Neighbour",
  "Other",
];

export const EMPLOYMENT_STATUS_OPTIONS = [
  "Employed",
  "Self-Employed",
  "Unemployed",
  "Student",
  "Retired",
  "Homemaker",
];

const NON_EDITABLE_EMPLOYMENT_STATUSES = new Set([
  "unemployed",
  "student",
  "retired",
  "homemaker",
]);

export const shouldDisableEmploymentDetails = (status) => {
  const normalized = String(status || "").trim().toLowerCase();
  return NON_EDITABLE_EMPLOYMENT_STATUSES.has(normalized);
};

/** For these statuses only `status` is meaningful; clear employer/work fields for API consistency. */
export const normalizeEmploymentInfoForStatus = (employment) => {
  if (!employment || typeof employment !== "object") return employment;
  if (!shouldDisableEmploymentDetails(employment.status)) return employment;
  return {
    ...employment,
    occupation: null,
    industry: null,
    employer: null,
    title: null,
    tin: null,
    address: null,
  };
};
